import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationBars from '../../../components/HOC/withNavigationBars';
import { Button, Alert, Loader, Breadcrumbs } from 'kangarootime-ui';
import actions from '../duck/actions';
import DataTable from '../../../components/DataTable';
import RaisedContainer from '../../../components/RaisedContainer';

class NewMenuMeals extends Component {
  constructor (props) {
    super(props);

    this.state = {
      mealData: [],
      showMenuCreationAlert: false,
      menuCreationAlertType: '',
      menuCreateAlertTitle: '',
      menuCreationAlertMessage: ''
    };
  }

  get breadcrumbs () {
    return [
      { label: 'Nutrition', link: null },
      { label: 'New Menu', link: null },
      { label: 'Add Meals', link: null }
    ];
  }

  get saveMealsButtonEnabled () {
    const { savingMenu } = this.props;
    const { mealData } = this.state;

    return mealData.length > 0 && !savingMenu;
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.savingMenu && !this.props.savingMenu && this.props.saveSuccessful) {
      this.showAlert('success', 'Success', 'Menu created successfully!');
    }

    if (prevProps.savingMenu && !this.props.savingMenu && !this.props.saveSuccessful && this.props.savingError !== '') {
      this.showAlert('danger', 'Error', this.props.savingError);
    }
  }

  showAlert = (type, title, message) => {
    this.setState({
      showMenuCreationAlert: true,
      menuCreationAlertType: type,
      menuCreateAlertTitle: title,
      menuCreationAlertMessage: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showMenuCreationAlert: false,
          menuCreationAlertType: '',
          menuCreateAlertTitle: '',
          menuCreationAlertMessage: ''
        }, () => {
          // navigate back to initial screen on successful menu creation
          if (this.props.saveSuccessful) {
            this.props.history.push('/menus');
          }
        });
      }, 3000);
    });
  }

  saveMeals = () => {
    const { mealData } = this.state;

    this.props.setMeals(mealData);
    this.props.createMenu();
  }

  // table editing functions
  onRowAdd = newData => (
    new Promise((resolve, reject) => {
      setTimeout(() => {
        {
          const { mealData } = this.state;
          mealData.push(newData);
          this.setState({ mealData }, () => resolve());
        }
        resolve();
      }, 1000);
    })
  );

  onRowUpdate = (newData, oldData) => (
    new Promise((resolve, reject) => {
      setTimeout(() => {
        {
          const { mealData } = this.state;
          const indexToUpdate = mealData.indexOf(oldData);
          mealData[indexToUpdate] = newData;
          this.setState({ mealData }, () => resolve());
        }
        resolve();
      }, 1000);
    })
  );

  onRowDelete = oldData => (
    new Promise((resolve, reject) => {
      setTimeout(() => {
        {
          const { mealData } = this.state;
          const indexToRemove = mealData.indexOf(oldData);
          mealData.splice(indexToRemove, 1);
          this.setState({ mealData }, () => resolve());
        }
        resolve();
      }, 1000);
    })
  );

  renderMealsTable = () => {
    const { mealData } = this.state;

    return (
      <DataTable
        title='Meals'
        columns={[
          {
            title: 'Meal',
            field: 'mealtime',
            lookup: {
              'breakfast': 'Breakfast',
              'am_snack': 'AM Snack',
              'lunch': 'Lunch',
              'pm_snack': 'PM Snack'
            }
          },
          {
            title: 'Food',
            field: 'food'
          }
        ]}
        data={mealData}
        editable={{
          onRowAdd: this.onRowAdd,
          onRowUpdate: this.onRowUpdate,
          onRowDelete: this.onRowDelete
        }}
        localization={{
          body: {
            emptyDataSourceMessage: 'No meals added'
          }
        }}
        options={{
          search: false
        }}
      />
    );
  }

  render () {
    const { savingMenu } = this.props;
    const { showMenuCreationAlert, menuCreateAlertTitle, menuCreationAlertMessage, menuCreationAlertType } = this.state;

    return (
      <NavigationBars>
        <div className='flex-columns flex-1'>
          <Breadcrumbs breadcrumbs={this.breadcrumbs} />
          <RaisedContainer>
            <div className='flex-rows' style={{ justifyContent: 'center', marginBottom: 16 }}>
              <Loader loading={savingMenu}>
                { showMenuCreationAlert && <Alert type={menuCreationAlertType} title={menuCreateAlertTitle}>{menuCreationAlertMessage}</Alert> }
              </Loader>
            </div>
            <div style={{ margin: 16 }}>
              { this.renderMealsTable() }
              <div className='flex-rows' style={{ marginTop: 24 }}>
                <Button
                  type='primary'
                  onClick={this.saveMeals}
                  disabled={!this.saveMealsButtonEnabled}
                >
                  Save Menu
                </Button>
                <Button
                  type='secondary'
                  onClick={() => this.props.history.push('/menus')}
                  style={{ marginLeft: 8 }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </RaisedContainer>
        </div>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    savingMenu: state.menus.newMenu.savingMenu,
    saveSuccessful: state.menus.newMenu.successfulCreation,
    savingError: state.menus.newMenu.errorMessage
  };
}

function mapDispatchToProps (dispatch) {
  return {
    setMeals: (meals) => dispatch(actions.setMenuMeals(meals)),
    createMenu: () => dispatch(actions.createNewMenuRequest())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewMenuMeals);
